<template>
  <el-container>
    <el-main>
      <menuList :menus="menuData"></menuList>
      <div class="content">
        <el-row>
          <el-col :span="12" class="header">
            <nav aria-label="breadcrumb">
              <ol class="bread clearfix">
                <li><router-link :to="{ name: 'MAIN_A' }"><i class="fas fa-home mint"></i></router-link></li>
                <li v-for="navi in naviPath" :key="navi.menu_code">{{navi.menu_name}}</li>
              </ol>
            </nav>
          </el-col>
          <el-col :span="12" class="user-info">
            {{`${userName} (${userId})`}}
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="el-dropdown-link">
                <img :src="`/static/img/${userType === 'A' ? 'admin' : 'tutor'}_2.png`" title="정보 변경" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="password"><i class="fa fa-edit"></i> 비밀번호 변경</el-dropdown-item>
                <el-dropdown-item command="logout"><i class="fas fa-sign-out-alt"></i> 로그아웃</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
        </el-row>
        <!-- 실제 구현 화면 -->
        <router-view :key="$route.fullPath"></router-view>
      </div>
    </el-main>
    <el-footer ref="footer">
      <div class="footer">
        <div class="logo"><img src="/static/img/white-2-row.png" title="권규호언어연구실"></div>
        <div class="footer-contents">
          <dl>
            <dt>(주)권규호언어연구실</dt>
            <dd>대표이사 권규호</dd>
          </dl>
          <dl>
            <dt>주소</dt>
            <dd>서울시 강남구 봉은사로 26길 12</dd>
          </dl>
          <dl>
            <dt>전화번호</dt>
            <dd><span class="number">070-8872-4389</span></dd>
          </dl>
          <dl>
            <dt>개인정보보호 책임자</dt>
            <dd>최은혜(<a href="mailto:kwonlabmanager@gmail.com">kwonlabmanager@gmail.com</a>)</dd>
          </dl>
        </div>

      </div>
    </el-footer>
  </el-container>
</template>

<script>

import menuList from '@/components/menu-list'
import axios from '@/modules/api-axios'

export default {
  name: 'ADMIN',
  components: {menuList},
  data () {
    return {
      naviPath: [],
      menuData: [],
      userName: this.$store.getters.user_name,
      userId: this.$store.getters.user_id,
      userSeq: this.$store.getters.user_seq,
      userType: this.$store.getters.user_type
    }
  },
  created () {
    // 초기 로그인 정보 다시 로드 필요?
    // 메뉴 조회
    this.getMenuAuth()
  },
  methods: {
    getMenuAuth () {
      if (!this.$store.getters.user_seq) {
        return
      }
      axios.get('/auth/user/' + this.$store.getters.user_seq)
        .then(response => {
          this.menuData = response.data
        })
        .catch(error => {
          this.$router.push({path: '/error', params: {message: error.response.data}})
        })
    },
    changePassword () {
      this.$router.push({name: 'USER_CHANGE_PASSWORD', params: {init_yn: 'N'}})
    },
    logout () {
      this.$confirm('로그아웃 하시겠습니까?', '', {
      }).then(() => {
        const userType = this.$store.getters.user_type
        this.$store.dispatch('AUTH_LOGOUT').then(() => {
          this.$router.push({name: 'LOGIN_' + userType})
          // window.location.href = '/'
        })
      }).catch(() => {})
    },
    handleCommand (command) {
      if (command === 'password') {
        this.changePassword()
      } else if (command === 'logout') {
        this.logout()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /*html {
    overflow-y: scroll;
  }*/
  .container {
    max-width: 1800px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Admin.vue